import React from "react";
import { MdClose } from "react-icons/md";

import Loader from "react-loader-spinner";
import "react-phone-input-2/lib/style.css";

export default function DeleteModal({
  showModal,
  loading,
  handleCancel,
  history,
  handleOk,
  footerOption1,
  footerOption2,
  type,
  t,
}) {
  return (
    <div>
      <div
        className="modal"
        style={{
          display: showModal ? "block" : "",
          alignItems: "center",
          top: "50%",
        }}
      >
        <div className="modal-dialog" style={{ maxWidth: "600px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 style={{ color: "white" }}></h5>
              <button
                type="button"
                className="close p-1 rounded"
                aria-label="Close"
                onClick={handleCancel}
                style={{ border: "none" }}
              >
                <MdClose />
              </button>
            </div>
            <div className="modal-body">
              {type === "logout" ? (
                <label className="font-15">
                  {" "}
                  Are you sure you want to log out?{" "}
                </label>
              ) : (
                <div>
                  <div>
                    <label> Are you sure to Delete ?</label>
                  </div>
                  {/* <a href="mailto:support@aamergroup.ae">Email Us support@aamergroup.ae</a>     */}
                </div>
              )}
            </div>

            <div className="modal-footer">
              {/* <button type="button" className="btn btn-light-danger font-weight-bold" onClick={handleCancel}>{footerOption2 ? footerOption2 : 'Cancel' }</button> */}
              <button
                type="button"
                className="btn btn-primary font-weight-bold d-flex align-items-center"
                onClick={handleOk}
                disabled={loading}
              >
                {footerOption1 ? footerOption1 : "Submit"}
                {loading && (
                  <Loader
                    type="Oval"
                    color="#fff"
                    height={20}
                    width={20}
                    style={{ marginLeft: "10px" }}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop show"></div>
    </div>
  );
}
